import * as types from './constants';

// Refresh Smart Group
export const refreshSmartGroupRequest = data => (
  { type: types.REFRESH_SMART_GROUP_REQUEST, payload: data }
);

export const refreshSmartGroupDone = data => (
  { type: types.REFRESH_SMART_GROUP_DONE, payload: data }
);

export const refreshSmartGroupFailed = errors => (
  { type: types.REFRESH_SMART_GROUP_FAILED, payload: errors }
);

export const refreshSmartGroupReset = errors => (
  { type: types.REFRESH_SMART_GROUP_RESET, payload: errors }
);